import gql from "graphql-tag";

export const REMOVE_REQUEST = gql`
  mutation($id: ID!) {
    removeRequest(id: $id) {
      _id
    }
  }
`;
